var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProtectedFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.547 3.88621L12.3595 0.071666C12.1293 -0.0238652 11.8706 -0.0239121 11.6405 0.071666L2.45302 3.88621C2.10309 4.03153 1.875 4.37315 1.875 4.75204V9.38915C1.875 15.7741 5.73417 21.5176 11.6457 23.9305C11.8728 24.0232 12.1272 24.0232 12.3543 23.9305C18.2657 21.5176 22.125 15.7742 22.125 9.38915V4.75204C22.125 4.37315 21.897 4.03153 21.547 3.88621ZM14.9933 8.5197L10.9638 12.5492L9.00665 10.5921C8.64056 10.226 8.04698 10.226 7.68084 10.5921C7.3147 10.9582 7.3147 11.5518 7.68084 11.9179L10.3009 14.5379C10.6669 14.904 11.2605 14.9041 11.6267 14.5379L16.3191 9.84552C16.6852 9.47942 16.6853 8.88585 16.3192 8.5197C15.953 8.15356 15.3594 8.15361 14.9933 8.5197Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectedFilled);
export default __webpack_public_path__ + "static/media/protected-filled.bfca4f8819759fc07a092c2d5a25d4d6.svg";
export { ForwardRef as ReactComponent };